<template>
  <div class="home-description">
    <div class="description-header">
      <div class="description-header-box">
        <div class="partner-center flex flex-center">
          <div :style="{ 'min-width': isMobile ? '90%' : '1201px' }">
            <Back
              :backText="$t('home_page')"
              @goBackRoute="goBackRoute"
              style="margin-bottom: 49px"
            ></Back>
          </div>
        </div>
        <p class="students">
          {{ $t('students_forward') }}
        </p>
        <h3 class="confidence-header">
          {{ $t('hsk_confidence') }}
        </h3>
        <!-- <video-player
          v-if="videoUrl && false"
          class="video-player vjs-custom-skin docs"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        >
        </video-player> -->
        <mui-button type="yellow" class="started" @click="addSchool">{{
          $t('try_it_out')
        }}</mui-button>
      </div>

      <img src="@/assets/images/home/home-description-header.png" alt="" style="display: block" />
    </div>
    <div>
      <div class="home-main" :class="{ 'home-main-mobile': isMobile }">
        <div class="confidence">
          <div class="confidence-card">
            <div
              class="confidence-card-item"
              :class="!isMobile ? 'card-pad-1' : 'confidence-card-item-mobile'"
            >
              <img
                src="@/assets/images/home/through.png"
                alt=""
                :class="!isMobile ? 'tests-mar-1' : 'confidence-mobile-img-1'"
              />
              <div class="card-text">
                <h1 class="card-text-title" :class="{ 'card-text-title-mobile': isMobile }">
                  {{ $t('walk_through') }}
                </h1>
                <p class="card-text-content" :class="{ 'card-text-content-mobile': isMobile }">
                  {{ $t('teachers_page_desc1') }}
                </p>
              </div>
            </div>
            <div
              class="confidence-card-item"
              :class="!isMobile ? 'card-pad-2' : 'confidence-card-item-mobile'"
            >
              <div class="card-text" v-if="!isMobile">
                <h1 class="card-text-title">{{ $t('assign_practice_papers') }}</h1>
                <p class="card-text-content">
                  {{ $t('teachers_page_desc2') }}
                </p>
              </div>
              <img
                src="@/assets/images/home/practice.png"
                alt=""
                :class="!isMobile ? 'tests-mar-2' : 'confidence-mobile-img-2'"
              />
              <div class="card-text" v-if="isMobile">
                <h1 class="card-text-title" :class="{ 'card-text-title-mobile': isMobile }">
                  {{ $t('assign_practice_papers') }}
                </h1>
                <p class="card-text-content" :class="{ 'card-text-content-mobile': isMobile }">
                  {{ $t('teachers_page_desc2') }}
                </p>
              </div>
            </div>
            <div
              class="confidence-card-item"
              :class="!isMobile ? 'card-pad-3' : 'confidence-card-item-mobile'"
            >
              <img
                src="@/assets/images/home/instant.png"
                alt=""
                :class="!isMobile ? 'tests-mar-3' : 'confidence-mobile-img-3'"
              />
              <div class="card-text">
                <h1 class="card-text-title" :class="{ 'card-text-title-mobile': isMobile }">
                  {{ $t('get_instant_results') }}
                </h1>
                <p class="card-text-content" :class="{ 'card-text-content-mobile': isMobile }">
                  {{ $t('teachers_page_desc3') }}
                </p>
              </div>
            </div>
            <div
              class="confidence-card-item"
              :class="!isMobile ? 'card-pad-4' : 'confidence-card-item-mobile'"
            >
              <div class="card-text" v-if="!isMobile">
                <h1 class="card-text-title">{{ $t('review_their_answers') }}</h1>
                <p class="card-text-content">
                  {{ $t('teachers_page_desc4') }}
                </p>
              </div>
              <img
                src="@/assets/images/home/answers.png"
                alt=""
                :class="!isMobile ? 'tests-mar-4' : 'confidence-mobile-img-4'"
              />
              <div class="card-text" v-if="isMobile">
                <h1 class="card-text-title" :class="{ 'card-text-title-mobile': isMobile }">
                  {{ $t('review_their_answers') }}
                </h1>
                <p class="card-text-content" :class="{ 'card-text-content-mobile': isMobile }">
                  {{ $t('teachers_page_desc4') }}
                </p>
              </div>
            </div>
            <div
              class="confidence-card-item"
              :class="!isMobile ? 'card-pad-5' : 'confidence-card-item-mobile'"
            >
              <img
                src="@/assets/images/home/progress.png"
                alt=""
                :class="!isMobile ? 'tests-mar-5' : 'confidence-mobile-img-5'"
              />
              <div class="card-text" :class="{ 'card-text-mobile': isMobile }">
                <h1 class="card-text-title" :class="{ 'card-text-title-mobile': isMobile }">
                  {{ $t('track_prog') }}
                </h1>
                <p class="card-text-content" :class="{ 'card-text-content-mobile': isMobile }">
                  {{ $t('teachers_page_desc5') }}
                </p>
              </div>
            </div>
          </div>
          <mui-button type="yellow" class="started" @click="addSchool">
            {{ $t('try_it_out') }}
          </mui-button>
        </div>
      </div>
    </div>
    <div class="next-level-card">
      <div class="next-level home-main">
        <h3 class="students-header">{{ $t('students_next_level') }}</h3>
        <p class="students-text">
          {{ $t('teachers_page_desc6') }}
        </p>
        <mui-button
          type="yellow"
          class="started"
          style="margin-top: 100px"
          @click="onClickTeachingRes"
        >
          {{ $t('teaching_resources') }}
        </mui-button>
      </div>
      <img src="@/assets/images/home/lorem.png" alt="" style="display: block; width: 100%" />
    </div>
    <div>
      <div class="lorem-bg" :class="{ 'lorem-bg-mobile': isMobile }">
        <div class="home-main" :class="{ 'home-main-mobile': isMobile }">
          <div class="flex flex-between test-card" :class="{ 'test-card-mobile': isMobile }">
            <div class="test-date" :class="{ 'test-date-mobile': isMobile }" @click="onClickDate">
              <p class="test-card-text">{{ $t('check_test_dates') }}</p>
              <img src="@/assets/images/home/test-date.png" alt="" class="test-date-img" />
            </div>
            <div class="test-book" :class="{ 'test-book-mobile': isMobile }" @click="onClickJoin">
              <p class="test-card-text">{{ $t('book_test') }}</p>
              <img src="@/assets/images/home/book-test.png" alt="" class="test-book-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from '@/components/common/Back.vue'
// 在线视频播放组件
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
// import { videoPlayer } from 'vue-video-player'
import { getToken } from '@/utils/cache'
import analytics from '@/utils/AnalyticsCenter'
import { pathUrl } from '@/config'
import { jumpToHankao } from '@/utils/utils'
export default {
  name: 'ForTeachersIndex',
  components: {
    Back,
    // videoPlayer,
  },
  data() {
    return {
      isMobile: false,
      videoUrl: '',
    }
  },
  watch: {
    '$store.state.publicUrl.mockPublicUrl': {
      handler(val) {
        if (val) {
          this.videoUrl = this.$store.state.publicUrl.mockPublicUrl + '/static/promo.mp4'
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName('frameHome')[0].scrollTop = 0
    })
  },
  computed: {
    // 预览配置
    playerOptions() {
      return {
        // width: '1675px',
        // height: '628px',
        aspectRatio: '2:1',
        autoplay: false,
        muted: false,
        controls: true,
        preload: 'auto',
        sources: [
          {
            type: 'video/mp4',
            src: this.videoUrl,
          },
        ],
      }
    },
  },

  methods: {
    goBackRoute() {
      this.$router.push('/home/index')
    },
    // 点击考试日期按钮
    onClickDate() {
      analytics.logEvent('hskweb_checktestdates_click')
      jumpToHankao(true)
    },
    // 点击报名考试按钮
    onClickJoin() {
      analytics.logEvent('hskweb_bookatest_click')
      jumpToHankao(false)
    },
    addSchool() {
      if (this.$store.state.user.login && getToken()) {
        this.$router.push({ path: '/addSchool/index' })
      } else {
        this.$store.dispatch('user/handleLogout', { reLogin: true })
      }
    },
    // 跳转我会
    onClickTeachingRes() {
      window.open(pathUrl.WOHUI)
    },
  },
}
</script>

<style lang="scss" scoped>
.home-description {
  background: #ffffff;
}

.description-header {
  background: #f4eeea;
  padding-top: 20px;

  .description-header-box {
    padding-bottom: 60px;
    margin: 0 122px;

    /*播放按钮设置成宽高一致，圆形，居中*/
    // ::v-deep .vjs-custom-skin > .video-js .vjs-big-play-button {
    //   outline: none;
    //   border: none;
    //   width: 100px;
    //   height: 100px !important;
    //   background-color: rgba(0, 0, 0, 0) !important;
    // }

    // ::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    //   width: 100px;
    //   height: 100px;
    //   border-radius: 50%;
    //   background-color: #ffffff40;
    //   font-size: 100px;
    //   position: relative;
    //   // background: url('../../assets/images/btn_play_hsk.png') no-repeat;
    //   background-size: 100% 100%;
    // }

    .students {
      color: var(--Wohui-0, #2c2f46);
      text-align: center;
      font-family: Inter;
      font-size: 40px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .confidence-header {
      color: var(--Wohui-0, #2c2f46);
      text-align: center;
      font-family: Inter;
      font-size: 80px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }
}

.started {
  width: 300px;
  height: 60px;
  border-radius: 50px !important;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 auto;
  margin-top: 60px;
}

.home-main {
  width: 1200px;
  margin: 0 auto;

  &-mobile {
    width: 100%;
  }
}

.confidence {
  background-color: #ffffff;
  padding-bottom: 80px;

  .confidence-card {
    // .card-pad-1 {
    //   padding: 0 200px 0 360px;
    // }
    .tests-mar-1 {
      margin-right: 170px;
    }

    // .card-pad-2 {
    //   padding: 0 255px 0 360px;
    // }
    .tests-mar-2 {
      margin-left: 144px;
    }

    .card-pad-3 {
      // padding: 0 232px 0 323px;
      margin-top: -70px;
    }

    .tests-mar-3 {
      margin-right: 143px;
    }

    .card-pad-4 {
      // padding: 0 232px 0 360px;
      margin-top: -35px;
    }

    .tests-mar-4 {
      margin-left: 134px;
    }

    .card-pad-5 {
      // padding: 0 202px 0 340px;
      margin-top: -75px;
    }

    .tests-mar-5 {
      margin-right: 192px;
    }

    .confidence-card-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-mobile {
        flex-direction: column;
      }

      .card-text-title {
        color: var(--Wohui-0, #2c2f46);
        font-family: Inter;
        font-size: 56px;
        font-style: normal;
        font-weight: 700;
        line-height: 60px;
        /* 75% */
        margin-bottom: 32px;

        &-mobile {
          font-size: 20px;
          text-align: center;
          margin-bottom: 12px;
          line-height: 40px;
        }
      }

      .card-text-content {
        color: #515571;
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        &-mobile {
          padding: 0 20px;
        }
      }

      .confidence-mobile-img-1 {
        display: block;
        width: 290px;
        height: 290px;
      }

      .confidence-mobile-img-2 {
        display: block;
        width: 290px;
        height: 290px;
      }

      .confidence-mobile-img-3 {
        display: block;
        width: 260px;
        height: 260px;
      }

      .confidence-mobile-img-4 {
        display: block;
        width: 260px;
        height: 260px;
      }

      .confidence-mobile-img-5 {
        display: block;
        width: 260px;
        height: 260px;
      }

      .card-text-mobile {
        margin-bottom: 55px;
      }
    }
  }
}

.next-level-card {
  background: #fafafb;

  .next-level {
    padding: 120px 0 80px 0;

    .students-header {
      color: var(--Wohui-0, #2c2f46);
      font-family: Inter;
      font-size: 56px;
      font-style: normal;
      font-weight: 700;
      line-height: 42px;
      margin-bottom: 80px;
      text-align: center;
    }

    .students-text {
      color: #515571;
      text-align: center;
      font-family: Inter;
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}

.lorem-bg {
  width: 100%;
  background-color: #2c2f46;
  margin-top: -1px;
  overflow: hidden;
  padding-bottom: 102px;

  // padding: 0 360px;
  &-mobile {
    height: auto;
    padding: 36px 29px;
  }

  .test-card {
    margin-top: 65px;
    margin-bottom: 60px;
    cursor: pointer;

    &-mobile {
      flex-direction: column;
      margin-top: 0;
      margin-bottom: 24px;
    }

    &-text {
      position: relative;
      color: #2d3047;
      font-family: Inter;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      z-index: 10;
    }

    .test-date {
      width: 558px;
      padding: 58px 40px;
      border-radius: 10px;
      border: 1px solid #d9ecfd;
      background: #fdf1d9;
      position: relative;

      &-img {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      &-mobile {
        width: 100%;
        padding: 45px 20px;
        margin-bottom: 20px;
      }
    }

    .test-book {
      width: 558px;
      padding: 58px 40px;
      border-radius: 10px;
      border: 1px solid #d9ecfd;
      background: #eaf2f9;
      position: relative;

      &-img {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      &-mobile {
        width: 100%;
        padding: 45px 20px;
      }
    }
  }

  .swiper-box {
    width: 100%;
    position: relative;

    .icon-58 {
      width: 58px;
      height: 58px;
    }

    .mySwiper-button-prev {
      position: absolute;
      top: 50%;
      left: -80px;
      z-index: 20;
      transform: translateY(-50%);
      cursor: pointer;
    }

    .mySwiper-button-next {
      position: absolute;
      top: 50%;
      right: -80px;
      z-index: 20;
      transform: translateY(-50%);
      cursor: pointer;
    }

    .swiper {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 332px;
      height: 482px;
      border-radius: 18px;
      background: #fff;

      .lorem-card {
        height: 100%;
        padding: 28px 40px;
        height: 482px;
        box-sizing: border-box;

        .lorem-more {
          display: block;
          color: #2d3047;
          text-align: center;
          font-family: Inter;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 32px;
        }

        .lorem-title {
          color: #2d3047;
          text-align: center;
          font-family: Inter;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 20px;
        }

        &-desc {
          margin-top: 20px;
          color: #515571;
          text-align: center;
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }

  .lorem-card-mobile {
    width: 100%;
    height: 482px;
    border-radius: 18px;
    background: #fff;
    margin-bottom: 24px;
    padding: 28px 25px;
    position: relative;

    &-desc {
      margin-top: 20px;
      color: #515571;
      text-align: center;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .lorem-title-mobile {
    color: #2d3047;
    text-align: center;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 20px;
  }

  .lorem-more-mobile {
    display: block;
    color: #2d3047;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 32px;
  }
}
</style>
